import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Page, Text, View, Document } from '@react-pdf/renderer';
import { pdfStyles } from './styles';
import tableData from "./tableData";

import FirstTable from './tables/firstTable';
import SecondTable from './tables/secondTable';
import ThirdTable from './tables/thirdTable';
import FourthTable from './tables/fourthTable';
import TableRenderer from './tables/fifthTable';

const PortfolioPrintPdf = ({ layoutData, user, photo, portfolio, group, gradebook, disciplineList, semestrName, practice, semesterGrades }) => {

    const [countOfPage, setCountOfPage] = useState(0)


    const resolveBigTableData = data => {
        const stack = [];
        const withEmptyPeriod = Object.values(data).map((period) => Object.values(period)).map((two, i) => two.length === 2 ? two : i % 2 !== 0 ? [[], ...two] : [...two, []])
        withEmptyPeriod.map(el => el.forEach(lol => stack.push(lol)))
        // Object.keys(data)
        //     .map(period => Object.keys(data[period])
        //         .map(el => data[period][el]))
        //     .forEach(el => {
        //         stack.push(el[0]);
        //         if (el.length === 2) {
        //             stack.push(el[1])
        //         } else {
        //             const termnum = el[0][0].termnum ? Number(el[0][0].termnum) : 1
        //             if (termnum%2) {
        //                 stack.push([])
        //             } else {
        //                 stack.unshift([])
        //             }
        //         }
        //     });
        return stack;
    }

    const renderTitles = (bigTitle, smallTitle, continuation) => (
        <View style={[pdfStyles.center, pdfStyles.mb10]}>
            {bigTitle && <Text style={[pdfStyles.subTitle]}>{bigTitle}</Text>}
            {/* {continuation && <Text style={pdfStyles.continuation}>{continuation}</Text>} */}
            {smallTitle && <Text style={pdfStyles.subSubTitle}>{smallTitle}</Text>}
        </View>
    );

    const renderSubTitles = (bigTitle, smallTitle) => (
        <View style={pdfStyles.center}>
            {bigTitle && <Text style={pdfStyles.bold}>{bigTitle}</Text>}
            {smallTitle && <Text style={[pdfStyles.smaller, pdfStyles.bold]}>{smallTitle}</Text>}
        </View>
    );

    const dataFieldsResolver = data => data.map(el => ({ name: el.name, type: el.participation, result: el.results }))

    const hugeTableData = useMemo(() => resolveBigTableData(gradebook), [gradebook]);

    return (
        <Document>

            <Page size="A4" style={pdfStyles.page}>
                <View style={pdfStyles.center}>
                    <Text style={pdfStyles.underline}>{"Министерство обороны Российской Федерации"}</Text>
                </View>
                <View style={[pdfStyles.center, pdfStyles.mb20]}>
                    <Text>{layoutData.data.GOU_Name}</Text>
                </View>
                <View style={[pdfStyles.center, pdfStyles.mb10]}>
                    <Text style={pdfStyles.title}>{"ПОРТФОЛИО"}</Text>
                </View>

                <FirstTable layoutData={layoutData} user={user} photo={photo} portfolio={group} />

                <View style={pdfStyles.mt50}>
                    <Text style={pdfStyles.ml10}>
                        {'Личная подпись обучающегося ________________'}
                    </Text>
                </View>

            </Page>

            <Page size="A4" style={pdfStyles.page}>
                <View style={pdfStyles.mt5}>
                    <Text style={[pdfStyles.ml10, pdfStyles.bold, pdfStyles.center]}>
                        {'Содержание'}
                    </Text>
                </View>

                <SecondTable tableData={tableData.secondTableData} gradebook={gradebook} countOfPage={countOfPage} />
            </Page>

            <Page size="A4" style={pdfStyles.page}>

                {renderTitles("1. Лист представления")}
                {renderSubTitles("Информация о предшествующем образовании")}

                <ThirdTable tableData={portfolio['portfolio_preveducation']} />

                <View style={[pdfStyles.center, pdfStyles.mb10]}>
                    {renderSubTitles("Дополнительная информация")}
                    <Text
                        style={[pdfStyles.smaller, pdfStyles.mb10]}>{"(владение иностранными языками, ПК (ОС и приложения), автомобилем и т. д.)"}</Text>
                    {/* <Text>{portfolio.portfolio_character}</Text> */}
                    <Text>{portfolio.portfolio_description}</Text>
                </View>

                <View style={[pdfStyles.center, pdfStyles.mb10]}>
                    {renderSubTitles("Интересы, предпочтения, хобби и т.д.")}
                    {/* <Text style={pdfStyles.smaller}>{portfolio.portfolio_description}</Text> */}
                    <Text style={pdfStyles.smaller}>{portfolio.portfolio_character}</Text>
                </View>

            </Page>
            {/* приходят настоящие данные */}
            <FourthTable semesterGrades={semesterGrades} renderTitles={renderTitles} renderSubTitles={renderSubTitles} disciplineList={disciplineList} setCountOfPage={setCountOfPage} />

            <Page size="A4" style={pdfStyles.page}>

                {renderTitles(null, "Раздел 2. Научная (научно-исследовательская) деятельность")}
                {renderSubTitles('Портфолио достижений', 'Участие в научно-практических конференциях и других научных мероприятиях')}

                {/* <TableRenderer tableData={dataFieldsResolver(portfolio['portfolio_scientific'])} */}
                <TableRenderer tableData={portfolio['portfolio_scientific'].length ? dataFieldsResolver(portfolio['portfolio_scientific']) : dataFieldsResolver([{ name: '', participation: '', results: '' }])} headers={tableData.headers} />

                {/* {               renderTitles(null, "Раздел 3. Дополнительные личные достижения")}
                {renderSubTitles('Портфолио достижений', 'Участие в общественной жизни академии')}

                <TableRenderer tableData={dataFieldsResolver(portfolio['portfolio_sociallife'])}
                               headers={tableData.headers}/>
                {renderSubTitles(null, 'Участие в спортивных и творческих мероприятиях')}

                <TableRenderer tableData={dataFieldsResolver(portfolio['portfolio_sport'])}
                               headers={tableData.headers}/> */}

                {renderTitles(null, "Раздел 3. Прохождение практик")}
                {renderSubTitles('Портфолио достижений', 'Результаты прохождения практик')}

                {/* <TableRenderer tableData={tableData.sixthTable} uppercaseGrades headers={tableData.headersGrade}/>  */}
                <TableRenderer practice={practice} headers={tableData.headersGrade} />

            </Page>


            <Page size="A4" style={pdfStyles.page}>
                {renderTitles(null, "Раздел 4. Дополнительные личные достижения")}

                {renderSubTitles('Портфолио достижений', 'Участие в спортивных и творческих мероприятиях')}
                <TableRenderer tableData={portfolio['portfolio_sport'].length ? dataFieldsResolver(portfolio['portfolio_sport']) : dataFieldsResolver([{ name: '', participation: '', results: '' }])}
                    headers={tableData.headers} />

                {renderSubTitles(null, 'Участие в общественной жизни академии')}
                <TableRenderer tableData={portfolio['portfolio_sociallife'].length ? dataFieldsResolver(portfolio['portfolio_sociallife']) : dataFieldsResolver([{ name: '', participation: '', results: '' }])}
                    headers={tableData.headers} />

            </Page>


        </Document>
    );
};

PortfolioPrintPdf.propTypes = {
    layoutData: PropTypes.object,
    user: PropTypes.object,
};

export default PortfolioPrintPdf;